import React, { useState, useEffect, useRef } from "react";
import { productservices } from "../../services/productServices";
import { Formik, Field, Form, useFormik } from 'formik';
import Bredcrum from '../../components/bredcrum';
import { useSelector } from 'react-redux';
import { Titlebar, Searchbox, Label } from '../../components/fieldsComp';
import { Overlayloader } from '../../components/loaderComp';
import { Toast } from 'primereact/toast';
import { Submissionbtn } from "../../components/buttons";
import {HandleClose} from '../../helpers/formclose';
const AddBOM = () => {

  const toast = useRef(null);
  const unitreducer = useSelector((state) => state.unitreducer);
  const [productlist, setProductlist] = useState([]);
  const [units, setUnits] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [components, setComponents] = useState([
    { componentName: "", quantity: "", cost: "" },
  ]);
  // const unitreducer = useSelector((state)=>state.unitreducer); 

  const [rows, setRows] = useState([{ id: Date.now(), quantity: 0 }]);

  const handleAddRow = () => {
    setRows([...rows, { id: Date.now(), quantity: 0 }]);
  };


  useEffect(() => {
    getproduct();
    getunits();
    getcomponents();
  }, []);

  const handleAddComponent = () => {
    setComponents([
      ...components,
      { componentName: "", quantity: "", cost: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };

  const getcomponents = () => {
    // setUserloaded(false);
    productservices.getcomponentsalldata().then((response) => {
      if (response.status == 200) {
        //   console.log(response.data.data);
        setResults(response.data.data);
        // setUserloaded(true);
      } else {
        setResults([]);
        // setUserloaded(true);
      }
    }).catch((error) => {
      setResults([]);
      // setUserloaded(true);
    });
  }


  const getproduct = () => {
    productservices.getallproductlist().then((response) => {
      if (response.status == 200) {
        setProductlist(response.data.data);
      } else {
        setProductlist([]);
      }

    }).catch((error) => {
      setProductlist([]);
    });
  }

  const displayproducts = () => {
    let temp = [];
    productlist.forEach((value, index) => {
      temp.push(<option value={value.id}>{value.product_name + ', Sku Code : ' + value.sku_code}</option>);
    })
    return temp;
  }

  const getunits = () => {
    let temparr = [];
    unitreducer.then((response) => {
      setUnits(response);
    }).catch((error) => {
    });
  }

  const displayunits = () => {
    let temparr = [];
    units.forEach((value, index) => {
      temparr.push(<option value={value.short_code}>{value.name}</option>)
    });
    return temparr;
  }

  const displayData = () => {
    let temparr = [];
    results.forEach((value, index) => {
      temparr.push(<option value={value.id}><span>Component : {value.component}</span> Sku : {value.componentSkuCode}</option>)
    })
    return temparr;
  }

  const handleSave = (values) => {
    // console.log("handle save");
    // console.log(values);
    setLoading(true);
    productservices.createbillofmaterial(values).then((response) => {
      // console.log(response);
      if (response.status == 200) {
        setLoading(false);
        toast.current.show({ severity: 'success', summary: 'Product', detail: `${response.data.data}` });
      } else {
        setLoading(false);
        toast.current.show({ severity: 'error', summary: 'Product', detail: `${response.data.data}` });
      }
    }).catch((error) => {
      setLoading(false);
      toast.current.show({ severity: 'error', summary: 'Product', detail: 'Error' });
    });
  };

  const productChanged = (e) => {
    console.log("Product changed");
    console.log(e.target.product_id);
  }



  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={'Create Bill Of Material'} divider={false} />
      {/* <div className="container mt-4"> */}
      {/* <Titlebar text={'Create Bill Of Material'} /> */}
      <div className="card shadow-sm p-3 rounded-4 p-40">
        <Formik
          initialValues={{
            product_name: '',
            sku_code: '',
            email: '',
            notes: ''
          }}
          onSubmit={async (values) => {
            handleSave(values);
          }}
        >
          {({ handleChange, setFieldValue, values }) => (
            <Form>
              <div className="row">
                <div className="col-md-6 form-group">
                  <Label name="Product" />
                  {/* <label className="form-label">Product</label> */}
                  <Field as="select" className="form-control" name="product_id" required onChange={(e)=>{
                       setFieldValue('product_id',e.target.value); 
                       const result = productlist.find(item => item.id == e.target.value);
                       setFieldValue('sku_code',result.sku_code);
                  }}>
                    <option value="">Select Product</option>
                    {displayproducts()}
                  </Field>
                  {/* <Field type="text"  name="product_name" className="form-control"
                                placeholder="Enter Product Name" required/> */}
                </div>

                <div className="col-md-6 form-group">
                      <Label name="Master SKU Code" />
                      <Field type="text" name="sku_code" className="form-control"
                      placeholder="Enter Master SKU Code" disabled/>
                </div>

                <div className='row'>
                  <div className="col-md-12 form-group">
                    {rows.map((row, index) => (
                      <div key={row.id} className="flex items-center m-1">
                        <div className='row'>
                          <div className="col-md-5 form-group">
                            <Label name="Select Compoent" />
                            <Field as="select" className="form-control" name={`components[${index}]`} required>
                              <option value="">Select Component</option>
                              {displayData()}
                            </Field>
                          </div>


                          <div className="col-md-3 form-group">
                            <Label name="Select Unit" />
                            <Field as="select" className="form-control" name={`units[${index}]`}>
                              <option value="">Select Units</option>
                              {displayunits()}
                            </Field>
                          </div>

                          <div className="col-md-3 form-group">
                            <Label name="Enter Quantity" />
                            <Field type="number" name={`quantity[${index}]`} className="form-control"
                              placeholder="Enter Quantity" required />
                          </div>

                          <div className="col-md-1">
                            <br></br>
                            <br></br>
                            <button
                              type="button"
                              onClick={() => handleRemoveRow(index)}
                              className="btn btn-outline-danger rounded  btn-sm"
                            >Remove</button>
                          </div>
                        </div>

                      </div>
                    ))}
                  </div>

                  <div className="col-md-2">
                    <button
                      type="button"
                      onClick={handleAddRow}
                      className="btn btn-outline-success rounded btn-sm"
                    ><i className="fa fa-plus"></i>
                    </button>
                  </div>

                </div>

                <div className="col-md-6 form-group">
                  <Label name="Notes" />
                  <Field as="textarea" name="notes" className="form-control"
                    placeholder="Enter Notes" required />
                </div>

              </div>
              <div className="d-flex justify-content-between">
                {/* <button className="btn text-white bg-brown col-md-6 me-2" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Loading...
                    </>
                  ) : (
                    "Save"
                  )}
                </button> */}
                <Submissionbtn issaved={!loading} label2="Saving" label="Save"/>
                {<HandleClose/>}
              </div>
            </Form>
          )}
        </Formik>


      </div>
      {/* </div> */}
    </>

  );
};

export default AddBOM;
